$(document).ready(function() {
  
    const modal1 = document.getElementById('shipping-nav-modal');
    const openModalBtnMobile = document.getElementById('shipping_mobile_open');
    const openModalBtn1 = document.getElementById('shipping_nav_pop_out');
    const closeModalBtn1 = document.getElementById('close_shipping');

    // Open the modal mobile
    if(openModalBtnMobile) {
      openModalBtnMobile.addEventListener('click', () => {
          modal1.style.display = 'block';
          document.body.style.overflow = 'hidden';
      });
    }
    
    // Open the modal
    if(openModalBtn1) {
      openModalBtn1.addEventListener('click', () => {
          modal1.style.display = 'block';
          document.body.style.overflow = 'hidden';
      });
    }
    
    // Close the modal
    if(closeModalBtn1) {
      closeModalBtn1.addEventListener('click', () => {
          modal1.style.display = 'none';
          document.body.style.overflow = 'unset';
      });
    }
  
  var AnnouncementSwiper = new Swiper(".announcement-swiper", {
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      enable: true,
    },
    autoplay: {
      delay: 50000,
      disableOnInteraction: false,
    },
  });

  $('.close-btn').on('click',function() {
      $('.redirect-popup').removeClass('flex');
  })
  
  // var links = document.links;
  //   for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  //     if (links[i].hostname !== window.location.hostname) {
  //       links[i].target = '_blank';
  //       links[i].rel = 'noreferrer noopener';
  //     }
  //   }
  // this.$parents.each(((e,n)=>{Ns()(n,(function(e){t()("."+r.activeClass).each((function(n){var i=t()(this);0===i.has(e.target).length&&i.removeClass(r.activeClass);}))}),(function(){})),!t()(n).hasClass("mega-menu")&&t()(n).parent().hasClass("site-nav")&&t()(n).on("mouseleave",(()=>{r.hideDropdown()}))})),
  $('div.site-header__wrapper ul.site-nav li.main-nav-li').on("click touchstart focusin",function(){
      $('#dark-overlay-onhover').css('visibility', 'visible');
  });


  
$('.main_mobile_nav_parent').click(function() {
  $(this).parent().find('.new_mobile_sublist_slide_out').toggleClass('active');
  // $('ul#parent_menu_mobile').css('visibility', 'hidden');
   $('ul#parent_menu_mobile').toggleClass('slide_to_right');
  
});
  
$('.mobile_parent_sub_div').click(function() {
  // setTimeout(() => {
  //    $('ul#parent_menu_mobile').css('visibility', 'visible');
  // }, "100");
    $('ul#parent_menu_mobile').toggleClass('slide_to_right');
  
  $(this).parent().toggleClass('active');
});

$('.main_mobile_nav_level_3').click(function() {
  $(this).closest('li').find('.new_mobile_sublist_slide_out_level_3').addClass('active');
});

$('.mobile_parent_sub_div_level_3_back').click(function() {
  $(this).closest('.new_mobile_sublist_slide_out_level_3').removeClass('active');
});

  $(document).on('click', function(){
	$('#dark-overlay-onhover').css('visibility', 'hidden');
    $('div.site-header__wrapper ul.site-nav li.main-nav-li').removeClass('nav-hover');
  });

  
  // $('div.site-header__nav ul.site-nav li.site-nav--has-dropdown').on('mouseleave focusout',function(){
  //   if($(this).children('.site-nav__dropdown').is(":hidden")) {
  //     console.log('false');
  //   }
  //   $('#dark-overlay-onhover').css('visibility', 'hidden');
  // });
  
  // var swiper2 = new Swiper("#product_thumbnails", {
  //     spaceBetween: 10,
  //   });

  
  // $(".swatch div.swatch-element").unbind('click');
  // $(".swatch div.swatch-element").click(function() {
  //   const swiper_thumbnails = $('#product_thumbnails .swiper-wrapper');

  //   let mediaJson = $('.media_slider').data('media-json');
  //   let mediaLength = $('.media_slider').data('media-length');

  //   let selectedVariant = $("input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
  //   let z = 0;
  //   // let checked_variant_color = $("input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
 
  //   $('#product_thumbnails .swiper-wrapper .swiper-slide').remove();
  //   for(let i = 0; i < mediaLength; i++) {
  //       let currentMedia = mediaJson[i + 1];
  //       if(currentMedia.media_type === 'image') {
  //             if(currentMedia.src.indexOf(selectedVariant) !== -1) {
  //                 // $(`<div class="swiper-slide"><a href="#" v-on:click="onMediaActivate" v-on:keydown="onMediaActivate" class="product-medias__thumbnail"><div class="class="responsive-image-product-wrapper""><img src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_1000x1000.jpg') : currentMedia.src.replace('.png', '_1000x1000.png')}" loading=lazy></div></a></div>`).appendTo(swiper_thumbnails);
  //               $(`<div class="swiper-slide"><a href="#" v-on:click="onMediaActivate" v-on:keydown="onMediaActivate" class="product-medias__thumbnail"><div class="responsive-image-product-wrapper"><img src="${currentMedia.src.includes('.jpg') ? currentMedia.src.replace('.jpg', '_200x200.jpg') : currentMedia.src.replace('.png', '_200x200.png')}" data-thumbnail-id="${z}"></div></a></div>`).appendTo(swiper_thumbnails);
  //                 z++;
  //             }
  //       }
  //   }
  //   // $('#swiper_thumbnails').swiper.removeAllSlides();
  //   // let checked_variant_color = $("input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
  //   // var checked_variant_size = false;
  //   // if($('body').attr('id').includes('desk-mat') || $('body').attr('id').includes('nest') ) {
  //   //   var checked_variant_size = $("input[name='option-2']:checked").val().toLowerCase().replace(/\s+/g, '-');
  //   // }
    
  //   // if(checked_variant_size){ 
  //   //   var selected_variant = checked_variant_color+'-'+checked_variant_size;
  //   // } else {
  //   //   var selected_variant = checked_variant_color;
  //   // }
    
  //   // $('.color-switch-header').html('Color: ' + $("input[name='option-1']:checked").val());
    
  //   // $('[thumbnail-color]').hide();
  //   // var selected_attribute = '[thumbnail-color="' + selected_variant + '"]';
  //   // if (selected_variant == selected_variant) {
  //   //     $(selected_attribute).show();
  //   //   } 
  // });

  /*
  $("body").on("click","#CollectionProductGrid .swatch-collections div.swatch-element.color input:radio", function() {
    // let checked_variant_color = $(this).find("input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
    let checked_variant_color = $("input[name='option-1']:checked").val().toLowerCase().replace(/\s+/g, '-');
    
    let for_product = $("input[name='option-1']:checked").attr("for-product-swatch");
    let for_product_size = $("input[name='option-1']:checked").attr("for-product-size");
    // console.log($(this));
    if( for_product_size != 'none') {
      var selected_variant = for_product+checked_variant_color+"-"+for_product_size;
    }else{
      var selected_variant = for_product+checked_variant_color;
    }
    $('['+for_product+'-thumbnail-color]').hide();
    var selected_attribute = '['+for_product+'-thumbnail-color="' + selected_variant + '"]';

    if (selected_variant == selected_variant) {
        $(selected_attribute).show();
      }
    
    // console.log($(e.target).attr("data-product-id"));
    // console.log($(this).find('.swatch-label'));
  });
  */
  var collectionSwatches = document.querySelectorAll('#CollectionProductGrid .swatch-collections div.swatch-element.color');
  collectionSwatches.forEach(function(swatch){
    swatch.addEventListener('click',function() {
      var value = this.closest('.swatch-element').getAttribute('data-value').toLowerCase();
      value = handleize(value);
      const productImageWrapper = this.closest('.grid-view-item').querySelector('.grid-view-item-image');
      const images = productImageWrapper.querySelectorAll('div:not(.hidden) > .responsive-image-wrapper img ');
      images.forEach(function(image){
        const forProduct = image.getAttribute('for-product');
        if (forProduct.indexOf(value) != -1 ) {
          image.style.display = 'block';
        } else {
          image.style.display = 'none';
        }
      });
    });
  });

  function handleize(str) {
    return str
      .toLowerCase() // Convert the string to lowercase
      .trim() // Remove whitespace from both ends of the string
      .replace(/[^a-z0-9\s-]/g, '') // Remove any character that is not a letter, number, space, or hyphen
      .replace(/\s+/g, '-') // Replace one or more spaces with a single hyphen
      .replace(/-+/g, '-'); // Replace multiple hyphens with a single hyphen
  }

  
    $('div#accordion_tab').find('.accordion-toggle').click(function(){
      //Expand or collapse this panel
      //$(this).find('span').toggleClass('open');
      $(this).next().slideToggle('fast');
      if($(this).find('span').hasClass('open')){
        $(this).find('span').removeClass('open');
      } else {
        $('.accordion-toggle span').removeClass('open');
        $(this).find('span').addClass('open');
      }    
      //Hide the other panels
      $(".accordion-content").not($(this).next()).slideUp('fast');    
    });

    $('div#accordion_faq').find('.accordion-toggle').click(function(){
      //Expand or collapse this panel
     
     if($(this).find('span').text() == '+') {
        $(this).find('span').text('-');
      } else {
       console.log($(this).find('span').text());
         $(this).find('span').text('+');
      }
     
      $(this).next().slideToggle(300);
      if($(this).find('span').hasClass('open')){
          // $(this).find('span').text('+');        
          $(this).find('span').removeClass('open');
      }else{
          // $('.accordion-toggle span').removeClass('open');
          // $('.accordion-toggle span').text('+');
          // $(this).find('span').text('-');
          $(this).find('span').addClass('open');
      }    
      //Hide the other panels
      // $(".accordion-content").not($(this).next()).slideUp('slow');    
    });
  
});